<template>
  <span>
    <template v-if="copyText">
      <template v-if="withoutIcon">
        <a-tooltip
          placement="topLeft"
          title="Copied"
          :visible="tooltipVisible"
          trigger="click"
          @click="onClick"
          arrow-point-at-center>
          <span
            v-clipboard:copy="copyText"
            v-clipboard:success="onCopy"
            class="mdi mdi-content-copy"
            title="Copy"
          >
            <slot />
          </span>
        </a-tooltip>
      </template>
      <template v-else>
        <slot />
        <a-tooltip
          placement="topLeft"
          title="Copied"
          :visible="tooltipVisible"
          trigger="click"
          @click="onClick"
          arrow-point-at-center>
          <i
            v-clipboard:copy="copyText"
            v-clipboard:success="onCopy"
            class="mdi mdi-content-copy"
            title="Copy" />
        </a-tooltip>
      </template>
    </template>
    <template v-else>
      <slot />
    </template>
  </span>
</template>

<script>

import ATooltip from 'ant-design-vue/lib/tooltip/Tooltip'
import 'ant-design-vue/lib/tooltip/style/index.css'

export default {
  name: 'copyable',
  components: {
    'a-tooltip': ATooltip,
  },
  props: {
    copyText: {
      type: [Number, String],
      required: true,
    },
    withoutIcon: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      tooltipVisible: false,
    }
  },
  methods: {
    onCopy (args) {
      this.tooltipVisible = true

      setTimeout(() => {
        this.tooltipVisible = false
      }, 3000)
    },
    onClick (evt) {
      evt.stopPropagation()
    },
  },
}
</script>

<style scoped>
  .mdi-content-copy {
    padding-left: 0.5em;
  }

  .mdi-content-copy:hover {
    cursor: pointer;
  }
</style>
